export default __webpack_public_path__ + "static/media/pic5.e6da1d3d.jpg";